function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-down"
}, /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "down",
  clipPath: "url(#clip-down)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Element_Icon_Caret",
  "data-name": "Element/Icon/Caret",
  transform: "translate(-1 -1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_-Icon-color",
  "data-name": "\\uD83C\\uDFA8-Icon-color",
  d: "M11.244-8.434,7.316-4.506a.447.447,0,0,1-.633,0L2.756-8.434a.447.447,0,0,1,0-.633l.316-.316a.447.447,0,0,1,.633,0L7-6.088l3.295-3.295a.447.447,0,0,1,.633,0l.316.316A.447.447,0,0,1,11.244-8.434Z",
  transform: "translate(0 13.889)",
  fill: "currentColor",
  fillRule: "evenodd"
})));

var SvgDown = function SvgDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/down.1a1a6456.svg";
export { ForwardRef as ReactComponent };